export default __webpack_public_path__ + "media/images/icons/award-solid-fd45eb92d9c98e32d599aa22fd96469f.svg";